import { AgUiEvent } from '../types/gateway-chat-types';

/**
 * Extracts the run identifier from an AG-UI event.
 * Checks multiple possible locations for the run ID.
 */
export const extractRunId = (event: AgUiEvent): string | undefined => {
  if (event.runId) {
    return event.runId;
  }

  const payload = event.payload ?? {};
  const runId = payload.runId ?? payload.run_id ?? payload.runID ?? payload.id;
  return typeof runId === 'string' ? runId : undefined;
};

/**
 * Resolves a message ID from a history message object.
 * Falls back to creating a deterministic ID based on index.
 */
export const resolveMessageId = (message: unknown, fallbackIndex: number): string => {
  if (typeof message !== 'object' || message === null) {
    return `history-${fallbackIndex}`;
  }

  const msg = message as Record<string, unknown>;
  const candidate = msg.id ?? msg.message_id ?? msg.runId ?? msg.run_id ?? msg.timestamp;

  if (typeof candidate === 'string') {
    return candidate;
  }

  if (candidate != null) {
    return String(candidate);
  }

  return `history-${fallbackIndex}`;
};

/**
 * Formats an ISO timestamp for display in event cards.
 */
export const formatEventTimestamp = (timestamp: string): string => {
  return new Date(timestamp).toLocaleString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

/**
 * Formats a timestamp for conversation activity display.
 */
export const formatConversationActivity = (timestamp: string): string => {
  return new Date(timestamp).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
